import React from 'react'
import { useTranslation } from 'i11n/client'
import { Spinner } from 'ui/spinner'

export const LoadingDataWrapperV2 = (props: {
  isLoading: boolean
  error?: unknown
  children: React.ReactNode
}) => {
  const t = useTranslation()

  if (props.isLoading) {
    return (
      <div className='mt-5 w-full'>
        <Spinner />
      </div>
    )
  }

  if (props.error) {
    return <p>{t('Algo no salió como se esperaba')}</p>
  }

  return <>{props.children}</>
}
